import {AjaxForm} from "./ajax-form";
import "../vendor/fraction";

window.AjaxForm = AjaxForm;

window.APP = Object.assign(window.APP, {
    user: {
        id: null,
        username: null,
        cookie: "gk_framework_user",
        polling: localStorage.getItem('userpoll') !== "0",

        init: function () {
            if ((new URLSearchParams(window.location.search)).get("logout")) {
                this.deleteCookie();
                APP.notify("Logout erfolgreich", "success");
            }
            if(APP.user.hasCookie()) {
                $.get('/gk-framework/auth/session').then(this.checkSession);
            }
            else {
                this.checkSession({});
            }
        },

        checkSession(data) {
            if (data.username) {
                APP.user.startSession(data);
            } else {
                $('#desktop-usermenu-cont').html('<a class="btn btn-primary" data-popup="/gk-framework/auth/login/modal" title="LOGIN"><span>LOGIN</span></a><a class="btn btn-secondary" href="/registrieren" title="REGISTRIEREN"><span>REGISTRIEREN</span></a>');
            }
        },

        /**
         * Set the current user session
         *
         * @param Object data
         */
        startSession(data) {
            this.poll(data)
            this.modifyPage()
            APP.trigger("userSession");
        },

        changePolling(val) {
            localStorage.setItem('userpoll', val ? "1" : "0")
            this.polling = val
            location.reload();
        },

        poll(data) {
            var user = APP.user;
            user.id = data.id
            user.username = data.username
            user.notifications(data.notifications)
            setTimeout(function () {
                if (user.polling) {
                    if (document.visibilityState == "visible") {
                        $.get('/gk-framework/auth/session').then(user.poll)
                    } else {
                        data.notifications = [];
                        APP.user.poll(data);
                    }
                }
            }, 3000)
        },

        notifications(array) {
            for (let i in array) {
                let item = array[i]
                APP.notify(item.msg, item.type, item.options)
            }
        },

        /**
         * do the page modifications, if the user is logged in
         */
        modifyPage() {
            $('#mobile_menu_user').css("background", 'var(--primary)')
            let co = '<div class="quicklinks customIcons subnav hidden" id="usernaviDiv" style="position: absolute"><ul>';
            const items = APP.user.userMenuItems;
            $('#desktop-usermenu-cont').html('<a class="btn btn-primary user-btn"><span>MEINE <strong>G</strong>UTE<strong>K</strong>UECHE</span></a>');

            for (let i in items) {
                let e = items[i];
                if (e === true)
                    co += '<li class="line"><hr></li>';
                else
                    co += '<li><a href="' + e[1] + '" class="text-secondary"><i class="icon-' + e[2] + '"></i> ' + e[0] + '</a></li>';
            }
            co += '</ul></div>';
            $("body").append(co);

            $(".user-btn").on("click", function () {
                let pos = $(this).offset();

                $("#usernaviDiv").css("top", pos.top + 62)
                    .css("left", pos.left)
                    .toggleClass("hidden");
            });
        },

        deleteCookie() {
            document.cookie = this.cookie +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        },

        hasCookie() {
            return document.cookie.split('; ').some(cookie => cookie.startsWith(this.cookie + '='))
        }
    },

    trigger: function (e) {
        if ("createEvent" in document) {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent(e, false, true);
            document.dispatchEvent(evt);
        } else
            document.fireEvent(e);
    },

    loadScript: function loadScript(url, callback) {
        var script = document.createElement('script');
        script.src = url;
        script.onreadystatechange = callback;
        script.onload = callback;
        document.getElementsByTagName('head')[0].appendChild(script);
    },

    adblock: function () {
        return window.gkAdsWerbung === undefined;
    },

    topnavi: {
        req: null,
        forceclose: false,

        /**
         * Close open slidedown-topnavi
         * @returns {boolean}
         */
        close: function () {
            this.req && this.req.abort();
            this.forceclose = true;
            this.selection();
            $("#middle, #footer").removeClass("opa");
            $("#navi_overlay_d").slideUp();
            return true;
        },

        /**
         * Updates (and opens) the slidedown-topnavi
         * @param $link
         */
        update: function ($link) {
            this.forceclose = false;
            this.selection($link.closest("li"));
            if (typeof this.req === "function") { // Is there already an opened topnavi?
                this.req.abort();
                $("#navi_overlay_d").slideUp();
            }

            APP.topnavi.req = $.ajax({
                url: "/topnavi/desktop?path=" + $link.attr("href"),
                context: document.body
            }).done(function (data) {
                if (this.forceclose) return this.close();
                $("#navi_overlay_d").html(data).slideDown();
                $("#middle, #footer").addClass("opa");
            });
        },

        /**
         * Clears the selection of a top-navi main point (and optionally sets a new one)
         * @param $new
         */
        selection: function ($new) {
            $("#header nav li").each(function () {
                var $this = $(this);
                if ($this.hasClass("active") && $this.find(">a").attr("href") != window.location.pathname) $this.removeClass("active");
            });
            $new && $new.addClass("active");
        }
    },

    scrollTo: function ($e) {
        $('html,body').animate({scrollTop: $e.offset().top - 25}, 500);
    },

    getAsync: function (url) {
        var data;
        $.ajax({
            url: url,
            async: false,
            success: function (result) {
                data = result;
            }
        });
        return data;
    },

    rest: function (url, options) {
        return $.ajax($.extend({
            url: url,
            error: function (a) {
                if (a.status == 401) {
                    alert("Sie sind nicht eingelogged!");
                    location.reload();
                } else {
                    alert("Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.");
                }
            }
        }, options));
    },

    userOnly: function (cb, params) {
        if (APP.user.id) {
            cb && cb.apply(this, params);
        } else {
            APP.onUserSession(function () {
                cb && cb.apply(this, params)
            });

            APP.openModal('/gk-framework/auth/login/modal', {
                type: 'ajax',
            })
        }
    },

    replaceQueryParam: function (param, newval, search) {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?")
        var query = search.replace(regex, "$1").replace(/&$/, '')
        return (query.length > 2 ? query + "&" : "?") + param + "=" + newval
    },

    getArticleId: function () {
        return $("[data-article]").data("article");
    },

    analytics: {
        event: function (name, param) {
            if (typeof gtag == "function") {
                gtag('event', name, param || {});
                console.log("GoogleAnalytics Log:", name, param || {})
            }
            else {
                console.log("GoogleAnalytics Log (no gtag available):", name, param || {})
            }
        }
    },

    pageView: function () {
        for(let i in this.pageViewActions) {
            this.pageViewActions[i]();
        }
    },

    openModal: function (urlOrId, options, index) {
        let src = urlOrId;

        if (urlOrId.charAt(0) === "#") {
            let item = $(urlOrId);
            return this.openModalInline(item.data("modalTitle"), item.html(), item.data("modalOkBtn"))
        }

        APP.pageView();
        options = $.extend(true, {
            type: 'ajax',
            items: {src: src},
            fixedContentPos: false,
            callbacks: {
                close: function () {
                    $("body").removeClass("modal-opened");
                },
                open: function () {
                    $("body").addClass("modal-opened");
                }
            }
        }, options || {});

        $.magnificPopup.open(options, index || 0);
    },

    openModalInline: function (title, body, addOkButton) {
        var html = '<div class="modal" style="width: 500px; max-width: 80%"><div class="modal-header">' + title + '</div>';
        html += '<div class="modal-body">' + body;
        if (addOkButton) html += '<div class="text-right sec"><a class="btn btn-primary popup-modal-dismiss">Ok</a></div>';
        html += '</div></div>';
        $(document).on('click', '.popup-modal-dismiss', function (e) {
            e.preventDefault();
            APP.closeModal();
        });
        return this.openModal(html, {
            closeOnBgClick: addOkButton ? false : true,
            items: {
                type: 'inline',
            }
        }, 0);
    },

    closeModal() {
        $.magnificPopup.close();
    },

    notify: function (msg, type = "success", options = {}) {
        // See https://notifyjs.jpillora.com/
        if (typeof msg == "object") {
            msg = '<div class="title">' + msg.title + '</div>' + msg.msg;
        }

        $.notify(msg, $.extend({
            clickToHide: false,
            autoHide: true,
            autoHideDelay: 10000,
            position: "bottom center",
            className: type,
            style: "bmdev"
        }, options));
    },

    onLoadObj: {
        array: [],

        run($ele) {
            for (let i in this.array) {
                let item = this.array[i];
                $ele.find(item.sel).each(item.fnc)
            }
        },

        add(sel, fnc) {
            $(sel).each(fnc);
            this.array.push({
                sel: sel,
                fnc: fnc
            })
        }
    },

    updateIngredientslist(gaEvent) {
        let $port = $("#portions"),
            port = $port.val();
        gaEvent = typeof gaEvent == "undefined" ? true : false;

        // Update other portion-attribute
        $("h2 .portions").html(port);
        $(".portions-unit").html(port == 1 ? $("h2 .portions-unit").data("portionsSingular") : $("h2 .portions-unit").data("portionsPlural"));

        // Track
        if (gaEvent) {
            APP.analytics.event("rezept_detail_portionen_berechnen");
            APP.pageView();
        }
        $(".recipe-ingredients table [data-amount]").each(function () {
            var $this = $(this),
                frac = new Fraction($this.data("amount"));
            $this.html(frac.divide($port.data("portions")).multiply(port).toString());
        });
    }
});

const GKF = {
    init: function (userMenuItems, readyCb) {
        // Document ready event
        $(document).ready(function () {
            GKF.ready(readyCb)
        })

        // GA
        APP.pageViewActions.push(function(){
            APP.analytics.event('page_view')
        });

        // Set vars
        APP.user.userMenuItems = userMenuItems;
    },

    ready: function (readyCb) {
        // First run app specific stuff
        readyCb();

        // Trigger contentchange event
        $.magnificPopup.defaults.callbacks = {
            ajaxContentAdded: function () {
                $(".modal").trigger("contentchange");
            },
            beforeOpen: function () {
                $('.tooltip.tooltipstered').tooltipster("hide");
            }
        };

        // Add custom notify class
        $.notify.addStyle('bmdev', {
            html: "<div><div class='close' title='schließen'>x</div><div class='left-box'></div><div class='content' data-notify-html/></div>",
        });
        //listen for click events from this style
        $(document).on('click', '.notifyjs-bmdev-base .close', function () {
            $(this).trigger('notify-hide');
        });

        // Check if loggedIn
        APP.user.init();

        $("body").on("submit", "form", function (e) {
            $(this).find("[data-text-min]").each(function () {
                var $this = $(this);
                if ($this.val().length < $this.data("text-min")) {
                    e.preventDefault();
                    $this.addClass("form-error-b");
                    $this.parent().find(".form-error").html("Bitte mindestens " + $this.data("text-min") + " Zeichen eingeben!");
                }
            });
        });

        $("body").on("click", ".linkarea", function (e) {
            if (e.target.nodeName != "A") {
                var lai = $(this).find(".linkarea-item");
                if (lai.length) {
                    lai.click();
                } else {
                    $(this).find("a").get(0).click();
                }
            }
        });

        $("body").on("click", "#navi_overlay_d a", function (e) {
            APP.analytics.event("topnavi_flyout");
        });

        // Track view
        APP.onUserSession(function () {
            if ($("[data-trackview]").length) {
                var trackView = $("[data-trackview]").data("trackview").split(",");
                $.ajax({
                    url: "/gk-framework/loyalty/pageview?cd=" + trackView[0] + "&id=" + trackView[1],
                    type: 'get'
                });
            }
        });

        // Tooltips
        APP.onLoadObj.add('.tooltip', function () {
            $(this).tooltipster();
        });

        // Ga-Track
        $("[data-gatrack]").on("click", function (e) {
            const d = $(this).data("gatrack");
            APP.analytics.event(d[0], d[1] || {});
        });

        $("body").on("click", ".close-alert", function () {
            $(this).closest(".alert").hide();
        });

        // Autocomplete search
        $('#search input').autocomplete({
            serviceUrl: '/modules/search/api' + ($("#container").data("section") ? "/" + $("#container").data("section") : ""),
            triggerSelectOnValidInput: false,
            maxHeight: 99999,
            groupBy: "group",
            formatResult: function (sug, curVal) {
                var result = '<a href="' + sug.url + '">' + sug.value;
                if (sug.type) result += " <small>(" + sug.type + ')</small>';

                return result + '</a>';
            },
            beforeRender: function (container) {
                $.Autocomplete.currentCategory = {};
            },
            onSelect: function (sug) {
                document.location.href = sug.url;
                return false;
            }
        });

        // Autocomplete-Select
        $("[data-autoselect]").each(function () {
            var $this = $(this);
            $this.find("input").autocomplete({
                serviceUrl: $this.data("autoselect"),
                minChars: 1,
                triggerSelectOnValidInput: false,
                onSelect: function (sug) {
                    document.location.href = sug.url;
                    return false;
                }
            });
        });

        // Modals for everyone
        $("body").on("click", "[data-popup]", function (e) {
            e.preventDefault();
            APP.openModal($(this).data("popup"));
        });

        // User only modals
        $("body").on("click", "[data-userpopup]", function (e) {
            e.preventDefault();
            APP.userOnly(function ($target) {
                APP.openModal($target.data("userpopup"))
            }, [$(this)]);
        });

        // AjaxForm and AjaxBtn
        AjaxForm.init({
            topOffset: 20,
            isProd: APP.isProdEnv,
            success: function () {
                APP.pageView();
            }
        });

        // User comments
        let UserComments = {
            init() {
                // Show User comment form
                APP.onLoadObj.add("#comment_n", function () {
                    UserComments.showForm($("#comment_n"), false);
                });
                $("body").on("click", "[data-comment]", (e) => {
                    UserComments.showForm($(e.target), true);
                });

                // Comment click into
                $("#comment_n").on("focus", "textarea", function () {
                    if (!APP.user.id) {
                        var $this = $(this);
                        $this.blur();
                        APP.userOnly(function () {
                            setTimeout(function () {
                                $this.focus();
                            }, 1);
                        }, []);
                    }
                });
            },
            showForm($div, checkUser) {
                let parent_id = $div.data("comment"),
                    $target = $("#comment_" + $div.data("comment")),
                    article = APP.getArticleId();

                if ($target.is(":empty")) {
                    const getForm = function ($target) {
                        let tpl = APP.getAsync("/plugins/user-comments/form/" + article + (parent_id != "n" ? "/" + parent_id : "") + window.location.search),
                            $tpl = $(tpl);
                        $target.html($tpl).slideToggle();
                        APP.onLoadObj.run($target);
                    };
                    checkUser ? APP.userOnly(getForm, [$target]) : getForm($target);
                } else if (checkUser) {
                    $target.slideToggle();
                }
            }
        };
        UserComments.init();


        // Google maps
        $('.popup-gmaps').magnificPopup({
            disableOn: 700,
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
                open: function () {
                    APP.pageView();
                }
            }
        });


        $("[data-selectupdate]").on("change", function () {
            var url = APP.replaceQueryParam($(this).data("selectupdate"), $(this).val(), window.location.search);
            url = APP.replaceQueryParam("p", 1, url);
            document.location.href = url;
        });

        // Mobile Menu
        const mobileNaviOpen = function (type) {
            $.ajax({
                url: "/topnavi/mobile?type=" + type,
                context: document.body
            }).done(function (data) {
                $("#middle, #footer, #ad_cont_mbanner2").addClass("hidden");
                $("body").addClass("mobile-menu-open");
                $("#navi_overlay_m").html(data).slideDown();
            });
        };
        $("#mobile_menu_main").on("click", function () {
            mobileNaviOpen("main");
        });
        $("#mobile_menu_user").on("click", function () {
            if (APP.user.id) {
                mobileNaviOpen("user");
            } else {
                APP.openModal('/gk-framework/auth/login/modal');
            }
        });
        $("#mobile_menu_close").on("click", function () {
            $("#middle, #footer, #ad_cont_mbanner2").removeClass("hidden");
            $("body").removeClass("mobile-menu-open");
            $("#navi_overlay_m").slideUp();
        });

        // Top Desktop navigation overlay
        $("#header nav").on("mouseover", "a", function () {
            APP.topnavi.update($(this));
        });
        $("#navi_overlay_d").on("mouseleave", function () {
            APP.topnavi.close();
        });

        // Toggle event
        $("body").on("click", "[data-toggle]", function (e) {
            e.preventDefault();
            $($(this).data("toggle")).slideToggle();
        });

        // Print action
        $("body").on("click", ".print-it", function (e) {
            APP.pageView();
            if (APP.adblock()) {
                APP.openModal('/gk-framework/articles/modal/slug/modal_adblock', {
                    callbacks: {
                        afterClose: function () {
                            document.location.reload();
                        }
                    }
                });
            } else {
                window.print();
            }
        });

        // Rezept-Detail - Add to einkaufsliste
        $("[data-einkaufsliste]").click(function (e) {
            var por = 1;
            if ($("#portions").length) {
                por = $("#portions").val();
                APP.updateIngredientslist();
            }

            APP.userOnly(function ($target) {
                APP.openModal("/user/einkaufsliste/add-rezept/" + $target.data("einkaufsliste") + "/" + por);
            }, [$(this)]);
        });

        // accordion
        $('body').on('click', '.accordion-header', function () {
            APP.pageView();
            $(this).parent().toggleClass('open');
        });

        $(".recipe-ingredients").on("submit", function (e) {
            e.preventDefault();
            APP.updateIngredientslist();
        });

        // Open Modal on page load
        var hash = document.location.hash;
        if (hash.startsWith('#modal=')) {
            APP.openModal(hash.substr(7));
        }

        // Trigger appRead
        APP.trigger("appReady");
    }
}

export default GKF;
